export const getGenTwoTempDefaultConfig = function () {
  return {
    sampleMode: '1',
    sampleModeCurrent: {
      modify: '1'
    },

    sampleInterval: 60,
    sampleIntervalCurrent: {
      modify: 60
    },

    normalReportInterval: 300,
    normalReportIntervalCurrent: {
      modify: 300
    },

    abnormalReportInterval: 300,
    abnormalReportIntervalCurrent: {
      modify: 300
    },

    syncInterval: 300,
    syncIntervalCurrent: {
      modify: 300
    },

    gapInterval: 60,
    gapIntervalCurrent: {
      modify: 60
    }
  }
}
